/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of the vehicle
 */
export type TrajectoryPointDtoVehicleType =
  (typeof TrajectoryPointDtoVehicleType)[keyof typeof TrajectoryPointDtoVehicleType];

export const TrajectoryPointDtoVehicleType = {
  car: "car",
  motorcycle: "motorcycle",
  bus: "bus",
  truck: "truck",
  bike: "bike",
  pedestrian: "pedestrian",
} as const;
